import { LinkTarget, Maybe } from '@/lib/types';

import { LinkTargetHTMLValue } from '@/enums/link-target';

const linkTargetMapper: Partial<Record<LinkTarget, LinkTargetHTMLValue>> = {
  [LinkTarget.NewTab]: LinkTargetHTMLValue.Blank,
};

export default function linkTargetTransformer(
  linkTarget: Maybe<LinkTarget> | LinkTarget | undefined
): LinkTargetHTMLValue | undefined {
  return (linkTarget && linkTargetMapper[linkTarget]) || undefined;
}
